exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#sig-canvas[data-v-19def6cc],#sig-image[data-v-19def6cc],.col-md-12[data-v-19def6cc],.row[data-v-19def6cc]{margin:0;padding:0;box-sizing:content-box!important}#sig-canvas[data-v-19def6cc]{border:2px solid #9cf;border-radius:1rem;margin-bottom:-6px;cursor:url(/src/assets/cursor.svg),pointer}#sig-canvas[data-v-19def6cc]:hover{border-color:#69c}#sig-image[data-v-19def6cc]{border:2px solid #ccc;border-radius:1rem}#sig-image[data-v-19def6cc]:hover{border-color:#999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-19def6cc","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/misc/ModalSign.vue
// module id = 174
// module chunks = 0